var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { registerToContextEvents } from './events/context';
import { BaseOneServiceI18n } from './BaseOneServiceI18n';
import { getPartnerLanguages, getSessionLocale, setPartnerLocale, setSessionLocale, } from './partner-languages/partnerLanguages';
var OneServiceI18n = /** @class */ (function (_super) {
    __extends(OneServiceI18n, _super);
    function OneServiceI18n() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OneServiceI18n.prototype.init = function (opts) {
        this.initializeLocale();
        return _super.prototype.init.call(this, opts);
    };
    OneServiceI18n.prototype.initializeLocale = function () {
        setPartnerLocale();
        registerToContextEvents(this.client);
    };
    OneServiceI18n.prototype.getSupportedLanguages = function () {
        return getPartnerLanguages();
    };
    OneServiceI18n.prototype.setLocale = function (localeCode) {
        setSessionLocale(localeCode);
    };
    OneServiceI18n.prototype.getLocale = function () {
        return getSessionLocale();
    };
    return OneServiceI18n;
}(BaseOneServiceI18n));
export { OneServiceI18n };
